var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContextMenuArtboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12h13V3.5a.5.5 0 00-.5-.5h-12a.5.5 0 00-.5.5V12zm.5-10h12A1.5 1.5 0 0116 3.5V13H1V3.5A1.5 1.5 0 012.5 2z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4 12l1.076 3.347a.5.5 0 01-.952.306L12.313 15H4.686l-.21.653a.5.5 0 01-.541.343l-.088-.02a.5.5 0 01-.323-.629L4.599 12H5.65l-.643 2h6.985l-.643-2H12.4zM8.024 1.347a.5.5 0 01.952 0L9.508 3H7.491zM.5 13h16a.5.5 0 100-1H.5a.5.5 0 100 1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextMenuArtboard);
export default __webpack_public_path__ + "static/media/context-menu-artboard.e73f5cd8.svg";
export { ForwardRef as ReactComponent };